import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, StorageService } from '../../service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(private storageService:StorageService,private authService:AuthService) {
  }
  canActivate(): boolean {
    const token = this.storageService.getItem('token');
    if (token) {
      this.authService.loginRedirect();
      return false; // Prevent navigation to the login page
    }
    else{
    return true; 
  }// Allow navigation to the login page if no token exists
  }
}
